import React from 'react';
import BrandAllListSummaryBox from '../BrandAllListSummaryBox';
import BrandAllList from '../BrandAllList';

const BrandAllListWrap = (props) => {
  const { brandList, currentTierList, openImgViewModal, getList, getExcelDownload, getBrandTagColumnTagList } = props;

  return (
    <div className="brand-all-list-wrap">
      {/*브랜드 집계 정보*/}
      <BrandAllListSummaryBox brandSummaryBox={brandList.brandSummaryBox} />

      {/*브랜드 리스트*/}
      <BrandAllList
        brandAllList={brandList}
        currentTierList={currentTierList}
        getList={getList}
        getExcelDownload={getExcelDownload}
        openImgViewModal={openImgViewModal}
        getBrandTagColumnTagList={getBrandTagColumnTagList}
      />
    </div>
  );
};

export default BrandAllListWrap;
